import React from 'react';
import Layout from 'components/Layout';
import { makeLocalize } from 'locales';
import NotFound from './NotFound';

import messages from './messages';

function action({ intl }) {
  const localize = makeLocalize(intl, messages);
  const title = localize('Сторінку не знайдено');
  return {
    title,
    component: (
      <Layout>
        <NotFound title={title} />
      </Layout>
    ),
    status: 404,
  };
}

export default action;
